import type { SpriNavigationItem } from '@spri/components/navigation';

/** Shared basic nav items duplicated across role navigations (Sonar dedup). */
export const patientsBasicNavigationItem: SpriNavigationItem = {
  id: 'patients',
  title: 'Patients',
  type: 'basic',
  icon: 'patient',
  link: '/patients',
};

export const positConnectBasicNavigationItem: SpriNavigationItem = {
  id: 'posit-connect',
  title: 'Posit Connect',
  type: 'basic',
  icon: 'heroicons_outline:chart-bar',
  link: '/posit-connect',
};
